import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import { IAppState } from './modules/app';
import user from './modules/user';

Vue.use(Vuex);

export interface IRootState {
  app: IAppState;
  user: user;
}

export default new Vuex.Store<IRootState>({
  modules: {
    user,
  },
  plugins: [createPersistedState()]
});
